<template>
  <div>
    <el-dialog title="参考酒店新增" :visible.sync="dialogVisible" width="50%">
      <div style="margin-top: 0.1rem;">
        <div class="typeDiv">
          <div :class="checkState==0?'checkType':''" @click="checkState=0">酒店</div>
          <div :class="checkState==4?'checkType':''" @click="checkState=4">餐厅</div>
        </div>
        <div>
          <el-checkbox v-model="allCheck" v-show="checkState==0" @change="allCheckMethod">全选</el-checkbox>
          <el-checkbox v-model="allCheck1" v-show="checkState==4" @change="allCheckMethod">全选</el-checkbox>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;{{resourceObj.nameCn}}</span>
        </div>
        <div v-for="(item,index) in productList" :key="index" style="margin-top: 0.1rem;">
          <div v-if="item.state==checkState">
            <el-checkbox v-model="item.isCheck">{{dateFormatYMD(item.stayDate,"-")}}&nbsp;&nbsp;{{item.resourceName}}</el-checkbox>
            <span v-if="item.referResource.length>0">&nbsp;&nbsp;&nbsp;已选参考酒店：</span>
            <span v-for="(item1,index1) in item.referResource" :key="index1">{{item1.nameCn}}
              <i class="el-icon-remove-outline" @click="deleteResource(item,index1)"></i>
            </span>&nbsp;
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
export default {
  props:{
    resourceObj:{
      type:Object,
      default:()=>{return{}}
    }
  },
  data(){
    return{
      dialogVisible:false,
      productList:[],
      allCheck:false,
      checkState:null,
      allCheck1:false,
    }
  },
  methods:{
    beforeOpen(budget){
      this.productList = []
      budget.planDayList.forEach(element => {
        element.budgetDetails.forEach(e=>{
          if((e.productType==1||e.productType==5)&&(e.state===0||e.state===4)){
            this.productList.push({
              budgetIds:e.budgetIds,
              resourceName:e.resourceNameCn,
              stayDate:element.planDate,
              isCheck:false,
              referResource:e.referResource&&e.referResource!=''?JSON.parse(e.referResource):[],
              state:e.state,
              obj:e,
            })
          }
        })
      });
      this.dialogVisible = true
      this.checkState = this.resourceObj.state
    },
    allCheckMethod(){     
      this.productList.forEach(e=>{
        if(e.state==this.checkState){
          e.isCheck = this.checkState==0?this.allCheck:this.allCheck1
        }
      }) 
    },
    deleteResource(item,index){
      item.referResource.splice(index,1)
      item.isDelete = true
    },
    save(){
      var dataList = []
      this.productList.forEach(ee=>{
        if(ee.isCheck||ee.isDelete){
          var referResource = ee.referResource;
          if(ee.isCheck){
            referResource.push(this.resourceObj)
          }
          ee.obj.referResource=JSON.stringify(referResource)
          ee.budgetIds.forEach(e=>{
            dataList.push({
              id:e,
              referResource:JSON.stringify(referResource)
            })
          })
        }
      })
      if(dataList.length>0){
        new PlanApi('plan').updateBudget(dataList).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"保存成功"})    
            this.dialogVisible = false
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })   
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.typeDiv{
  display: flex;
  margin-bottom: 0.1rem;
  >div{
    width: 0.5rem;
    height: 0.3rem;
    border: 1px solid #606266;
    line-height: 0.3rem;
    text-align: center;
  }
  >div:last-child{
    border-left:none ;
  }
}
.checkType{
  background-color: #DB4E1A;
  color: white;
  border: none !important;
}
</style>